import { useChatStore } from '../store/chat.js';

/**
 * 연결이 정상이 아닐 때만 나타난다.
 *
 * 늘 켜두는 앱이라 끊긴 줄 모르고 혼잣말을 계속하는 상황이 제일 나쁘다.
 * 정상일 때는 아무것도 보여주지 않아 화면을 차지하지 않는다.
 */
export function ConnectionBanner() {
  const status = useChatStore((s) => s.status);
  const detail = useChatStore((s) => s.statusDetail);

  if (status === 'open') return null;

  const { text, tone } = describe(status, detail);

  return (
    <div
      role="status"
      className={`px-4 py-1.5 text-center text-xs ${
        tone === 'error' ? 'bg-red-950 text-red-200' : 'bg-amber-950 text-amber-200'
      }`}
    >
      {text}
    </div>
  );
}

function describe(
  status: ReturnType<typeof useChatStore.getState>['status'],
  detail: string | null,
): { text: string; tone: 'warn' | 'error' } {
  switch (status) {
    case 'connecting':
      return { text: '연결하는 중…', tone: 'warn' };
    case 'reconnecting':
      return {
        text: detail ? `연결이 끊겼습니다 — 다시 시도하는 중 (${detail})` : '연결이 끊겼습니다 — 다시 시도하는 중',
        tone: 'warn',
      };
    case 'failed':
      return { text: detail ?? '연결할 수 없습니다', tone: 'error' };
    case 'closed':
      return { text: '방에서 나왔습니다', tone: 'warn' };
    case 'open':
      return { text: '', tone: 'warn' };
  }
}
